module.exports = __webpack_public_path__ + "img/g1.6a1025ba.jpg";